export default "__VITE_ASSET__DsnVvkGV__"